import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Package, Truck, Shield, Star, Zap, Award } from 'lucide-react';
import { products } from '../mock';
import SEO from '../components/SEO';
import ProductsPageBanner from '../components/ProductsPageBanner';

const ProductsPage = () => {
  const [selectedCandyType, setSelectedCandyType] = useState('swedish');
  const [currentCarouselImage, setCurrentCarouselImage] = useState(0);
  const [currentAlienCarouselImage, setCurrentAlienCarouselImage] = useState(0);
  const [currentHeartCarouselImage, setCurrentHeartCarouselImage] = useState(0);
  const [currentFoxCarouselImage, setCurrentFoxCarouselImage] = useState(0);
  const [currentBearCarouselImage, setCurrentBearCarouselImage] = useState(0);
  const [currentButterflyCarouselImage, setCurrentButterflyCarouselImage] = useState(0);
  const [currentCupcakeCarouselImage, setCurrentCupcakeCarouselImage] = useState(0);
  const [currentBunnyCarouselImage, setCurrentBunnyCarouselImage] = useState(0);
  const [currentStarsCarouselImage, setCurrentStarsCarouselImage] = useState(0);
  const [currentIcecreamCarouselImage, setCurrentIcecreamCarouselImage] = useState(0);
  const [currentHeart2CarouselImage, setCurrentHeart2CarouselImage] = useState(0);
  const [currentMixedCarouselImage, setCurrentMixedCarouselImage] = useState(0);

  // Handle scrolling to anchor on page load
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Wait for page to render
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Scroll to top if no hash
      window.scrollTo(0, 0);
    }
  }, []);

  // Carousel images for Skull Candy
  const skullCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_mitocandydev/artifacts/421ju7kd_grapeskull.jpg", 
      alt: "Grape Skull",
      objectFit: "cover"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/b8hofrw6_IMG_0182.png",
      alt: "Watermelon Skull",
      objectFit: "cover"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_mitocandydev/artifacts/kksdkken_yellow%20skulls.jpg",
      alt: "Yellow Skulls",
      objectFit: "cover"
    }
  ];

  // Carousel images for Alien Candy
  const alienCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_katomito-candy/artifacts/n6dq5o8z_Untitled27_20251117203702.jpeg",
      alt: "Premium Alien Candy Collection"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/ddej130x_IMG_0179.png",
      alt: "Blue and Pink Alien Candy"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_kato-mito-upgrade/artifacts/ffn0oh1g_Untitled31_20251120020906.jpeg",
      alt: "Green and Pink Alien Candy"
    }
  ];

  // Carousel images for Heart Candy
  const heartCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_katomito-candy/artifacts/z3nrbmyp_Untitled28_20251117212319.png",
      alt: "Premium Heart Candy Collection"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/7kjvx6uz_IMG_5401.png",
      alt: "Heart Yellow & Orange"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/f1spnr95_IMG_5398.jpeg",
      alt: "Pink & Blue Love Hearts"
    }
  ];

  // Carousel images for Fox Candy
  const foxCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/dvab0dek_IMG_7081.jpeg",
      alt: "Yellow & Brown Fox Candy"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/3g9by2lw_IMG_7071.jpeg",
      alt: "Watermelon Foxes - Pink & Green"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/w9ehn7xt_IMG_7074.jpeg",
      alt: "Mango Foxes - Orange & Yellow"
    }
  ];

  // Carousel images for Bear Candy
  const bearCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_katomito-candy/artifacts/25wdcrub_Untitled19_20251110185501.jpeg",
      alt: "Sour Bear Blueberry & Strawberry"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_katomito-candy/artifacts/fvhad0dr_Untitled20_20251110203816.jpeg",
      alt: "Sour Bear Mango"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/zj5lxk00_IMG_0184.png",
      alt: "Yellow & Brown Bear"
    }
  ];

  // Carousel images for Butterfly Candy
  const butterflyCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_katomito-candy/artifacts/08sjuupq_Untitled26_20251117202715.jpeg",
      alt: "Premium Butterfly Candy Collection"
    }
  ];

  // Carousel images for Cupcake Candy
  const cupcakeCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/2jr18vz2_IMG_0187.png",
      alt: "Banana Toffee Cupcake"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/rs013vhs_IMG_0186.png",
      alt: "Sweet Passionfruit & Grape Cupcake"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/aoydnkot_IMG_0188.png",
      alt: "Strawberry & Blueberry Cupcake"
    }
  ];

  // Carousel images for Bunny Candy
  const bunnyCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/lccqptwd_IMG_7123.jpeg",
      alt: "Pink & Blue Bunny Candy"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/gy4mq37f_IMG_0183.jpeg",
      alt: "Orange & Yellow Bunny Candy Mix"
    }
  ];

  // Carousel images for Stars Candy
  const starsCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/ac05xpi3_IMG_7134.jpeg",
      alt: "Colorful Stars Candy"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/k3a9d8fa_IMG_7129.jpeg",
      alt: "Yellow Star Candy"
    }
  ];

  // Carousel images for Icecream Candy
  const icecreamCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/52n8sva5_IMG_0180.jpeg",
      alt: "Sour Strawberry & Vanilla Icecream"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/kks8t7pn_IMG_0181.jpeg",
      alt: "Sweet Mango & Lychee Icecream"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/0zzmnls8_IMG_7140.jpeg",
      alt: "Sour Tutti-Frutti Icecream"
    }
  ];

  // Carousel images for Heart Candy 2 (different flavors)
  const heart2CandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/t0yevp3t_IMG_5399.jpeg",
      alt: "Tutti-Frutti Hearts - Yellow & Green"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/vggewnhn_IMG_5400.jpeg",
      alt: "Watermelon Hearts - Pink & Green"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/51c96zmn_IMG_7064.jpeg",
      alt: "Lemon & Blueberry Hearts - Blue & Yellow"
    }
  ];

  // Carousel images for Mixed Candy
  const mixedCandyImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/xxgksqhq_IMG_6821.jpeg",
      alt: "Kärlek Mix - Hearts, Butterflies & Bears"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/u1sql8o9_IMG_6826.jpeg",
      alt: "Glädje Mix - Skulls & Aliens"
    }
  ];

  // Auto-rotate carousel every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCarouselImage((prev) => (prev + 1) % skullCandyImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [skullCandyImages.length]);

  // Auto-rotate alien carousel every 4 seconds (different timing)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAlienCarouselImage((prev) => (prev + 1) % alienCandyImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [alienCandyImages.length]);

  // Auto-rotate heart carousel every 5 seconds (different timing)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeartCarouselImage((prev) => (prev + 1) % heartCandyImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heartCandyImages.length]);

  // Auto-rotate fox carousel every 6 seconds (different timing)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFoxCarouselImage((prev) => (prev + 1) % foxCandyImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [foxCandyImages.length]);

  // Auto-rotate bear carousel every 7 seconds (different timing)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBearCarouselImage((prev) => (prev + 1) % bearCandyImages.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [bearCandyImages.length]);

  // Auto-rotate butterfly carousel every 8 seconds (different timing)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentButterflyCarouselImage((prev) => (prev + 1) % butterflyCandyImages.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [butterflyCandyImages.length]);

  // Auto-rotate cupcake carousel every 3.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCupcakeCarouselImage((prev) => (prev + 1) % cupcakeCandyImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [cupcakeCandyImages.length]);

  // Auto-rotate bunny carousel every 4.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBunnyCarouselImage((prev) => (prev + 1) % bunnyCandyImages.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [bunnyCandyImages.length]);

  // Auto-rotate stars carousel every 5.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStarsCarouselImage((prev) => (prev + 1) % starsCandyImages.length);
    }, 5500);
    return () => clearInterval(interval);
  }, [starsCandyImages.length]);

  // Auto-rotate icecream carousel every 6.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIcecreamCarouselImage((prev) => (prev + 1) % icecreamCandyImages.length);
    }, 6500);
    return () => clearInterval(interval);
  }, [icecreamCandyImages.length]);

  // Auto-rotate heart2 carousel every 7.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeart2CarouselImage((prev) => (prev + 1) % heart2CandyImages.length);
    }, 7500);
    return () => clearInterval(interval);
  }, [heart2CandyImages.length]);

  // Auto-rotate mixed carousel every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMixedCarouselImage((prev) => (prev + 1) % mixedCandyImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [mixedCandyImages.length]);

  const candyTypes = [
    { id: 'swedish', name: 'Swedish Style Candy', icon: '🇸🇪', color: 'from-kato-navy to-kato-cyan' },
    { id: 'crystal', name: 'Crystal Candy', icon: '💎', color: 'from-purple-500 to-pink-500' }
  ];

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'retail':
        return Package;
      case 'bulk':
        return Zap;
      case 'custom':
        return Star;
      default:
        return Package;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'retail':
        return 'bg-kato-cyan';
      case 'bulk':
        return 'bg-kato-yellow';
      case 'custom':
        return 'bg-kato-navy';
      default:
        return 'bg-kato-cyan';
    }
  };

  return (
    <div className="min-h-screen">
      <SEO 
        title="Swedish Candy Products | Global Bulk Wholesale Foamy Candy & Skull Candy"
        description="Explore our premium Swedish candy collection available worldwide. Bulk wholesale Swedish candy including foamy candy, skull candy, and custom confections. International B2B candy supplier shipping globally to retailers across all continents."
        keywords="Swedish candy products, bulk wholesale candy, foamy candy, skull candy, international candy supplier, global wholesale candy, Swedish gummies worldwide, candy supplier Europe Asia"
        canonical={`${process.env.REACT_APP_BASE_URL || "https://katomito.com"}/products`}
      />
      
      {/* Products Page Banner - Glädje, Kärlek, Crystal Candy */}
      <ProductsPageBanner />
      
      {/* Why Choose Our Swedish Style Gummies Section */}
      <section id="products-grid" className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=%2260%22 height=%2260%22 viewBox=%220 0 60 60%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cg fill=%22%23E0F7FA%22 fill-opacity=%220.3%22%3E%3Ccircle cx=%227%22 cy=%227%22 r=%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-40"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-kato-navy mb-8">
              Why choose Our <span className="text-kato-cyan">Swedish Style Gummies?</span>
            </h2>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* 100% Vegan */}
            <div className="bg-white/40 backdrop-blur-sm border border-cyan-200/50 rounded-3xl p-8 text-center hover:scale-105 transition-all duration-300 hover:shadow-xl group">
              <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <span className="text-3xl">🌱</span>
              </div>
              <h3 className="text-2xl font-black text-kato-navy mb-4 group-hover:text-green-600 transition-colors">
                100% Vegan
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Plant-based ingredients for conscious consumers who don't compromise on taste.
              </p>
            </div>

            {/* Gluten Free/Gelatine Free/Dairy Free */}
            <div className="bg-white/40 backdrop-blur-sm border border-cyan-200/50 rounded-3xl p-8 text-center hover:scale-105 transition-all duration-300 hover:shadow-xl group">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <span className="text-3xl">✨</span>
              </div>
              <h3 className="text-2xl font-black text-kato-navy mb-4 group-hover:text-blue-600 transition-colors">
                Gluten Free
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Gelatine Free & Dairy Free for all dietary preferences and restrictions.
              </p>
            </div>

            {/* European Flavor */}
            <div className="bg-white/40 backdrop-blur-sm border border-cyan-200/50 rounded-3xl p-8 text-center hover:scale-105 transition-all duration-300 hover:shadow-xl group">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <span className="text-3xl">🍭</span>
              </div>
              <h3 className="text-2xl font-black text-kato-navy mb-4 group-hover:text-purple-600 transition-colors">
                European Flavor
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Authentic Swedish taste with sophisticated European flavor combinations.
              </p>
            </div>

            {/* Natural Colors */}
            <div className="bg-white/40 backdrop-blur-sm border border-cyan-200/50 rounded-3xl p-8 text-center hover:scale-105 transition-all duration-300 hover:shadow-xl group">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <span className="text-3xl">🌈</span>
              </div>
              <h3 className="text-2xl font-black text-kato-navy mb-4 group-hover:text-pink-500 transition-colors">
                Natural Colors
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Mostly natural colors with the ability to go fully natural upon request.
              </p>
            </div>
          </div>

          {/* Decorative candy icons floating around with pop animations */}
          <div className="absolute top-20 left-10 text-4xl opacity-20 animate-heartPop -z-10" style={{animationDelay: '0.5s'}}>🍬</div>
          <div className="absolute top-40 right-20 text-3xl opacity-30 animate-heartPop -z-10" style={{animationDelay: '1s'}}>🧸</div>
          <div className="absolute bottom-20 left-1/4 text-5xl opacity-15 animate-heartPop -z-10" style={{animationDelay: '1.5s'}}>🍭</div>
          <div className="absolute bottom-32 right-1/3 text-3xl opacity-25 animate-heartPop -z-10" style={{animationDelay: '2s'}}>🌟</div>
          <div className="absolute top-16 left-1/3 text-3xl opacity-20 animate-heartPop -z-10" style={{animationDelay: '0.8s'}}>🍩</div>
          <div className="absolute top-60 left-16 text-4xl opacity-18 animate-heartPop -z-10" style={{animationDelay: '1.2s'}}>🧁</div>
          <div className="absolute bottom-40 right-16 text-3xl opacity-22 animate-heartPop -z-10" style={{animationDelay: '1.8s'}}>🎂</div>
          <div className="absolute top-32 right-1/4 text-4xl opacity-16 animate-heartPop -z-10" style={{animationDelay: '2.2s'}}>🍪</div>
          <div className="absolute bottom-16 left-1/2 text-3xl opacity-24 animate-heartPop -z-10" style={{animationDelay: '0.3s'}}>🧊</div>
          <div className="absolute top-8 right-8 text-5xl opacity-12 animate-heartPop -z-10" style={{animationDelay: '2.5s'}}>🍰</div>
          <div className="absolute bottom-8 left-8 text-3xl opacity-28 animate-heartPop -z-10" style={{animationDelay: '1.7s'}}>🎀</div>
          <div className="absolute top-24 left-2/3 text-4xl opacity-14 animate-heartPop -z-10" style={{animationDelay: '0.9s'}}>🌺</div>
        </div>
      </section>

      {/* Swedish-Style Bags Banner */}
      <section className="py-8 relative" style={{ backgroundColor: '#221D58' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/ia3a5vdi_Untitled58_20260302071413.jpeg"
              alt="Swedish Style Candy Logo"
              className="w-auto h-auto max-w-[200px] sm:max-w-[250px] md:max-w-[300px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Swedish-Style Bags Section */}
      <section className="py-20 relative" style={{ backgroundColor: '#221D58' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Candy Bag 1 - Glädje */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_6ac4bdbf-67f7-47ec-b09b-67fbadc46f28/artifacts/gi3hqgh6_IMG_1038.png"
                  alt="Glädje Candy Bag"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col h-[520px]">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Glädje
                </h3>
                <p className="text-white mb-6 leading-relaxed flex-grow">
                  This vibrant candy bag is inspired by the Swedish tradition called lördagsgodis – sharing candy with family or friends on Saturdays. Glädje, meaning happiness in Swedish, is the feeling you get from one bite of this premium candy bag. Full of playful skulls and alien characters, tasting both sour and sweet. Vegan, gelatin free and gluten free.
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors and shapes included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                      Sour Grape Skull
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                      Watermelon Alien
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Banana Toffee Skull
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Sour Passion Fruit & Pineapple Alien
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Candy Bag 2 - Kärlek */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_6ac4bdbf-67f7-47ec-b09b-67fbadc46f28/artifacts/cs5dffur_IMG_1037.png"
                  alt="Kärlek Candy Bag"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col h-[520px]">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Kärlek
                </h3>
                <p className="text-white mb-6 leading-relaxed flex-grow">
                  This bag is inspired by the Swedish love for Pick & Mix candy and contains four different flavors, creating a beautiful candy blend of both sour and sweet. Kärlek, meaning Love in Swedish, is a premium candy bag with adorable bear characters, butterflies, and hearts. Vegan, gelatin free and gluten free.
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors and shapes included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Strawberry & Vanilla Heart
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      Sour Blueberry & Strawberry Bear
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Sour Lemon & Strawberry Butterfly
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Sour Mango Bear
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Candy Bag 3 - Belåten */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/89gqpke5_Untitled47_20260224072006.png"
                  alt="Belåten Candy Bag"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '500px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Belåten
                </h3>
                <p className="text-white mb-6 leading-relaxed">
                  Belåten is inspired by the Swedish saying "mätt och belåten" – the feeling of complete satisfaction after finishing a delicious treat. This bag captures that moment of pure contentment with a delightful mix of ice cream cones, hearts, and fox-shaped gummies. Like all our bags, Belåten is vegan, gelatin free and gluten free.
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors and shapes included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-amber-700 rounded-full mr-3"></div>
                      Sour Cola Fox
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
                      Sweet Mango & Lychee Icecream
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-400 rounded-full mr-3"></div>
                      Raspberry & Blueberry Fox
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-400 rounded-full mr-3"></div>
                      Tutti-Frutti Icecream
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                  data-testid="belaten-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Candy Bag 4 - Drömmar */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/57gq6yd2_Untitled47_20260224071353.png"
                  alt="Drömmar Candy Bag"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '500px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Drömmar
                </h3>
                <p className="text-white mb-6 leading-relaxed">
                  Drömmar, meaning dreams in Swedish, is a dreamy collection of our finest Swedish-style candy. Featuring cupcakes, love hearts, and ice cream cones in pastel colors, this bag is perfect for those who love soft, sweet flavors. Vegan, gelatin free and gluten free.
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors and shapes included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
                      Banana Toffee Cupcake
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-400 rounded-full mr-3"></div>
                      Sweet Strawberry & Vanilla Heart
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-400 rounded-full mr-3"></div>
                      Sweet Mango & Lychee Icecream
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-purple-400 rounded-full mr-3"></div>
                      Sweet Passionfruit & Grape Cupcake
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                  data-testid="drommar-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>

          {/* Mini Section Heading */}
          <div className="mt-20 mb-12 text-center">
            <h3 className="text-3xl md:text-4xl font-black" style={{ color: '#F5ED3A' }}>
              Mini
            </h3>
            <p className="text-white/70 mt-4 text-lg">Mini Foamy Swedish Style Candy</p>
          </div>

          {/* Mini Candy Bags Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Mini 1 - Strawberry Vanilla Heart (Pink Theme) */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-pink-400" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '300px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/oiihj3hc_IMG_0213.png"
                  alt="Strawberry Vanilla Heart - Mini Foamy"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '320px' }}>
                <h3 className="text-2xl font-black mb-4 transition-colors" style={{ color: '#EC4899' }}>
                  Strawberry Vanilla Heart
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#EC4899' }}>
                  Sweet strawberry and creamy vanilla blend in these adorable heart-shaped mini foamy gummies. Love in every bite!
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-sm" style={{ color: '#EC4899' }}>Flavors:</h4>
                  <p className="font-semibold" style={{ color: '#EC4899' }}>Strawberry & Vanilla</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-3 rounded-2xl text-lg font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#EC4899', color: '#FFFFFF' }}
                  data-testid="mini-heart-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Mini 2 - Watermelon Alien (Green Theme) */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-green-400" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '300px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/v7as2cmc_IMG_0212.png"
                  alt="Watermelon Alien - Mini Foamy"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '320px' }}>
                <h3 className="text-2xl font-black mb-4 transition-colors" style={{ color: '#22C55E' }}>
                  Watermelon Alien
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#22C55E' }}>
                  Out-of-this-world watermelon flavor in fun alien shapes. Juicy, refreshing, and sweet-coated for extra deliciousness!
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-sm" style={{ color: '#22C55E' }}>Flavor:</h4>
                  <p className="font-semibold" style={{ color: '#22C55E' }}>Watermelon</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-3 rounded-2xl text-lg font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#22C55E', color: '#FFFFFF' }}
                  data-testid="mini-alien-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Mini 3 - Lemon Cola Butterfly (Yellow Theme) */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-yellow-400" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '300px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/8vzw75wg_IMG_0211.png"
                  alt="Lemon Cola Butterfly - Mini Foamy"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '320px' }}>
                <h3 className="text-2xl font-black mb-4 transition-colors" style={{ color: '#FACC15' }}>
                  Lemon Cola Butterfly
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#FACC15' }}>
                  Zesty lemon meets classic cola in beautiful butterfly shapes. A fizzy, tangy treat that takes flight!
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-sm" style={{ color: '#FACC15' }}>Flavors:</h4>
                  <p className="font-semibold" style={{ color: '#FACC15' }}>Lemon & Cola</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-3 rounded-2xl text-lg font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#FACC15', color: '#1E1B4B' }}
                  data-testid="mini-butterfly-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Mini 4 - Sour Peach Game Over (Cyan Theme) */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-cyan-400" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '300px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/54m6y78i_IMG_0210.png"
                  alt="Sour Peach Game Over - Mini Foamy"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '320px' }}>
                <h3 className="text-2xl font-black mb-4 transition-colors" style={{ color: '#22D3EE' }}>
                  Sour Peach Game Over
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#22D3EE' }}>
                  Level up your candy game with these sour peach gummies shaped like iconic "Game Over" text. Game on!
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-sm" style={{ color: '#22D3EE' }}>Flavor:</h4>
                  <p className="font-semibold" style={{ color: '#22D3EE' }}>Sour Peach</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-3 rounded-2xl text-lg font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#22D3EE', color: '#1E1B4B' }}
                  data-testid="mini-gameover-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Mini 5 - Bubble Gum Gaming (Purple Theme) */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-purple-400" style={{ backgroundColor: '#221D58' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '300px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/uhm56rc7_IMG_0209.png"
                  alt="Bubble Gum Gaming - Mini Foamy"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '320px' }}>
                <h3 className="text-2xl font-black mb-4 transition-colors" style={{ color: '#A855F7' }}>
                  Bubble Gum Gaming
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#A855F7' }}>
                  Classic bubble gum flavor in fun controller shapes. Press play on these nostalgic, sweet foamy treats!
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-sm" style={{ color: '#A855F7' }}>Flavor:</h4>
                  <p className="font-semibold" style={{ color: '#A855F7' }}>Bubble Gum</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-3 rounded-2xl text-lg font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#A855F7', color: '#FFFFFF' }}
                  data-testid="mini-gaming-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Chocolate Dipped Banner */}
      <section className="py-8 relative" style={{ backgroundColor: '#311817' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/jdcopxw6_Namnlo%CC%88s%20design.png"
              alt="Chocolate Dipped Candy Logo"
              className="w-auto h-auto max-w-[150px] sm:max-w-[180px] md:max-w-[220px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Chocolate Dipped Section */}
      <section id="chocolate-dipped" className="py-20 relative overflow-hidden" style={{ backgroundColor: '#FFEFAD' }}>
        {/* Candy Doodles Background - Bigger, 2 on each side */}
        {/* Left side - Heart (top) and Alien (bottom) - Malmö candies */}
        <img
          src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/elc4u395_Namnlo%CC%88s%20design.png"
          alt="Heart Candy Doodle"
          className="absolute w-28 h-28 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain opacity-50"
          style={{ top: '10%', left: '2%', transform: 'rotate(-12deg)' }}
        />
        <img
          src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/qz9fd78e_Namnlo%CC%88s%20design.png"
          alt="Alien Candy Doodle"
          className="absolute w-28 h-28 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain opacity-50"
          style={{ bottom: '10%', left: '3%', transform: 'rotate(8deg)' }}
        />
        
        {/* Right side - Bear (top) and Skull (bottom) - Stockholm candies */}
        <img
          src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/req8pasn_Namnlo%CC%88s%20design.png"
          alt="Bear Candy Doodle"
          className="absolute w-28 h-28 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain opacity-50"
          style={{ top: '10%', right: '2%', transform: 'rotate(12deg)' }}
        />
        <img
          src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/4zq12d1u_Namnlo%CC%88s%20design.png"
          alt="Skull Candy Doodle"
          className="absolute w-28 h-28 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain opacity-50"
          style={{ bottom: '10%', right: '3%', transform: 'rotate(-8deg)' }}
        />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Malmö - Pink Bag */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-pink-400" style={{ backgroundColor: '#FFEFAD' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/7fb9xef7_IMG_0208.png"
                  alt="Malmö - Chocolate Dipped"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '340px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#EC4899' }}>
                  Malmö
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#5C2E1A' }}>
                  Premium Swedish gummies wrapped in smooth milk chocolate. A delicious treat.
                </p>
                <div className="mb-6 flex-grow">
                  <h4 className="font-black mb-3 text-lg" style={{ color: '#5C2E1A' }}>Flavors included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center font-semibold" style={{ color: '#EC4899' }}>
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Mango
                    </li>
                    <li className="flex items-center font-semibold" style={{ color: '#EC4899' }}>
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Strawberry & Vanilla
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#EC4899', color: '#FFFFFF' }}
                  data-testid="chocolate-malmo-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Stockholm - Yellow Bag */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-yellow-500" style={{ backgroundColor: '#FFEFAD' }}>
              <div className="relative overflow-hidden p-8" style={{ height: '400px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/xewqbeay_IMG_0207.png"
                  alt="Stockholm - Chocolate Dipped"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '340px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#CA8A04' }}>
                  Stockholm
                </h3>
                <p className="mb-6 leading-relaxed font-semibold" style={{ color: '#5C2E1A' }}>
                  Tropical Swedish gummies coated in rich milk chocolate. An irresistible delight.
                </p>
                <div className="mb-6 flex-grow">
                  <h4 className="font-black mb-3 text-lg" style={{ color: '#5C2E1A' }}>Flavors included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center font-semibold" style={{ color: '#CA8A04' }}>
                      <div className="w-2 h-2 bg-yellow-600 rounded-full mr-3"></div>
                      Banana Toffee
                    </li>
                    <li className="flex items-center font-semibold" style={{ color: '#CA8A04' }}>
                      <div className="w-2 h-2 bg-yellow-600 rounded-full mr-3"></div>
                      Pineapple Split
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#CA8A04', color: '#FFFFFF' }}
                  data-testid="chocolate-stockholm-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Crystal Candy Banner */}
      <section className="py-8 relative overflow-hidden" style={{ backgroundColor: '#90E4FF' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_279ff17a-327c-4c2c-8938-25803493c98b/artifacts/flvyx4ab_Namnlo%CC%88s%20design.jpeg"
              alt="Crystal Candy Logo"
              className="w-auto h-auto max-w-[320px] sm:max-w-[400px] md:max-w-[500px] max-h-[60px] sm:max-h-[75px] md:max-h-[90px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Crystal Candy Section */}
      <section id="crystal-candy" className="py-20 relative">
        {/* Ombré Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/wyfxvpud_Untitled%20design%20-%201.png"
            alt="Crystal Candy Background"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-center">
            {/* Crystal Candy - Aurora Fruit - Full Width Card with 3 Bags */}
            <div className="w-full rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 group border-4 border-transparent hover:border-cyan-400 bg-gradient-to-r from-[#0088cc] via-[#88ddff] to-[#ff9944]">
              <div className="relative overflow-hidden p-8 flex justify-center items-center gap-4" style={{ height: '450px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/kjp1q9gi_IMG_0206.png"
                  alt="Crystal Candy - Aurora Fruit"
                  className="h-full w-auto object-contain transition-all duration-1000 group-hover:scale-105"
                />
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/kjp1q9gi_IMG_0206.png"
                  alt="Crystal Candy - Aurora Fruit"
                  className="h-full w-auto object-contain transition-all duration-1000 group-hover:scale-105"
                />
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/kjp1q9gi_IMG_0206.png"
                  alt="Crystal Candy - Aurora Fruit"
                  className="h-full w-auto object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-8 flex flex-col bg-gradient-to-r from-[#0088cc]/90 via-[#88ddff]/90 to-[#ff9944]/90">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#1E3A5F' }}>
                  Aurora Fruit
                </h3>
                <p className="mb-6 leading-relaxed font-semibold text-lg" style={{ color: '#1E3A5F' }}>
                  The new trend is here, Crystal Candy! A completely new texture developed to be both crunchy and soft. These Aurora Crystals are inspired by the northern lights and the frozen winters in the highest parts of Sweden. The outside of the candy has a crystallized icy coating, which surrounds its soft center. Each Aurora Crystal has two different fruity flavors, giving a crunchy flavor explosion in each bite.
                </p>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg" style={{ color: '#1E3A5F' }}>Flavors included:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center font-semibold" style={{ color: '#1E3A5F' }}>
                      <div className="w-2 h-2 bg-blue-800 rounded-full mr-3"></div>
                      Mango
                    </li>
                    <li className="flex items-center font-semibold" style={{ color: '#1E3A5F' }}>
                      <div className="w-2 h-2 bg-blue-800 rounded-full mr-3"></div>
                      Strawberry
                    </li>
                    <li className="flex items-center font-semibold" style={{ color: '#1E3A5F' }}>
                      <div className="w-2 h-2 bg-blue-800 rounded-full mr-3"></div>
                      Grape
                    </li>
                    <li className="flex items-center font-semibold" style={{ color: '#1E3A5F' }}>
                      <div className="w-2 h-2 bg-blue-800 rounded-full mr-3"></div>
                      Blueberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#1E3A5F', color: '#FFFFFF' }}
                  data-testid="crystal-candy-order-btn"
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Sour Oozies Banner */}
      <section className="py-8 relative" style={{ backgroundColor: '#274890' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/z8iu64wz_Untitled%20design.png"
              alt="Sour Oozies Logo"
              className="w-auto h-auto max-w-[150px] sm:max-w-[180px] md:max-w-[220px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Sour Oozies Section */}
      <section id="sour-oozies" className="py-20 relative">
        {/* Blue Ombré Background */}
        <div className="absolute inset-0">
          <img
            src="https://customer-assets.emergentagent.com/job_c595f328-dcbe-4efb-85a7-83fb2ae491af/artifacts/hvbi9oue_Untitled%20design.png"
            alt="Sour Oozies Background"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Description Above Products */}
          <div className="text-center mb-12">
            <p className="text-2xl md:text-3xl font-black text-white max-w-4xl mx-auto leading-relaxed" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
              Sour candy is the hottest trend right now! Our Sour Oozies pack an intense flavor punch where you can taste every distinct flavor in each bite. Bold, tangy, and absolutely delicious!
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Blue Razz Blast - Blue Theme */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-blue-300 bg-transparent">
              <div className="relative overflow-hidden p-8" style={{ height: '350px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/dcakou8k_IMG_0202.png"
                  alt="Blue Razz Blast"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '220px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#1E3A8A' }}>
                  Blue Razz Blast
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-lg" style={{ color: '#1E3A8A' }}>Flavor:</h4>
                  <p className="font-semibold text-lg" style={{ color: '#1E3A8A' }}>Sour Blue Raspberry</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#1E3A8A', color: '#FFFFFF' }}
                  data-testid="sour-oozies-order-btn-1"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Watermelon Blast - Red Theme */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-red-400 bg-transparent">
              <div className="relative overflow-hidden p-8" style={{ height: '350px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/m7ohas4j_IMG_0204.png"
                  alt="Watermelon Blast"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '220px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#DC2626' }}>
                  Watermelon Blast
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-lg" style={{ color: '#DC2626' }}>Flavor:</h4>
                  <p className="font-semibold text-lg" style={{ color: '#DC2626' }}>Sour Watermelon</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#DC2626', color: '#FFFFFF' }}
                  data-testid="sour-oozies-order-btn-2"
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Cotton Candy Blast - Pink Theme */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-pink-400 bg-transparent">
              <div className="relative overflow-hidden p-8" style={{ height: '350px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_af784ae6-49de-4cf3-bbe7-0b767949d154/artifacts/i4bfj94o_IMG_0205.png"
                  alt="Cotton Candy Blast"
                  className="w-full h-full object-contain transition-all duration-1000 group-hover:scale-105"
                />
              </div>
              
              <div className="p-6 flex flex-col" style={{ minHeight: '220px' }}>
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#EC4899' }}>
                  Cotton Candy Blast
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-2 text-lg" style={{ color: '#EC4899' }}>Flavor:</h4>
                  <p className="font-semibold text-lg" style={{ color: '#EC4899' }}>Sour Cotton Candy</p>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center mt-auto"
                  style={{ backgroundColor: '#EC4899', color: '#FFFFFF' }}
                  data-testid="sour-oozies-order-btn-3"
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      
      {/* Bulk Options for Pick & Mix Section */}
      <section id="bulk-options" className="py-20 bg-black relative overflow-hidden" style={{ scrollMarginTop: '80px' }}>
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1499195333224-3ce974eecb47?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2251&q=80"
            alt="Colorful candy display background"
            className="w-full h-full object-cover opacity-40 blur-sm"
            onError={(e) => {
              // Fallback to gradient background if image fails to load
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-pink-500 via-purple-500 to-blue-500 opacity-30"></div>';
            }}
          />
        </div>

        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center text-white">
            <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight">
              Bulk Options for <span className="text-kato-yellow">Pick & Mix</span>
            </h2>
            
            <div className="max-w-4xl mx-auto">
              <p className="text-xl md:text-2xl font-bold mb-8 text-kato-cyan">
                We are glad to share that our Swedish Style Gummies are now available in Bulk!
              </p>
              
              <p className="text-lg md:text-xl leading-relaxed mb-6 opacity-90">
                Crafted to delight and evoke emotion, each piece in our gummies collection is designed to be as memorable as the moment it is enjoyed! Our bulk candy range features a vibrant mix of textures, flavors, and playful shapes, all wrapped in our signature foamy Swedish-style gummy base.
              </p>
              
              <p className="text-lg md:text-xl leading-relaxed mb-12 opacity-90">
                From sour aliens to sweet hearts, our gummies make every bite unforgettable. Have a look at our products below.
              </p>

              {/* Decorative elements */}
              <div className="flex justify-center items-center space-x-4 mb-8">
                <div className="w-2 h-2 bg-kato-yellow rounded-full animate-pulse"></div>
                <div className="w-3 h-3 bg-kato-cyan rounded-full animate-pulse delay-500"></div>
                <div className="w-2 h-2 bg-kato-yellow rounded-full animate-pulse delay-1000"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Where Treat Meets Trend Section */}
      <section className="py-20 relative" style={{ backgroundColor: '#221D58' }}>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black mb-6" style={{ color: '#F5ED3A' }}>
              Where <span style={{ color: '#4CC8ED' }}>Trend Meets Treat</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Tile 1: Skull Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {skullCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {skullCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Skull Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                      Grape
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                      Watermelon
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Banana Toffee
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Strawberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 2: Alien Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {alienCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentAlienCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {alienCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentAlienCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentAlienCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Alien Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Passion Fruit & Pineapple
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Bubblegum
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                      Watermelon
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Strawberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 3: Heart Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {heartCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentHeartCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {heartCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentHeartCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentHeartCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Heart Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Strawberry & Vanilla
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Orange & Passion Fruit
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Bubblegum
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      Blueberry & Strawberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 4: Fox Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {foxCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover scale-110 transition-all duration-1000 group-hover:scale-125 ${
                      index === currentFoxCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {foxCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentFoxCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentFoxCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Fox Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Banana & Toffee
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Cherry & Apple
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Mango
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 5: Bear Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {bearCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentBearCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {bearCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentBearCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentBearCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Bear Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      Blueberry & Strawberry
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Mango
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
                      Lemon & Cola
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 6: Butterfly Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {/* Carousel Images */}
                {butterflyCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentButterflyCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                
                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {butterflyCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentButterflyCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentButterflyCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Butterfly Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Lemon & Strawberry
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Bubblegum
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Cherry & Apple
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 7: Cupcake Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {cupcakeCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover scale-125 transition-all duration-1000 group-hover:scale-150 ${
                      index === currentCupcakeCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                    style={{ objectPosition: 'center 40%' }}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {cupcakeCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentCupcakeCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentCupcakeCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Cupcake Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Banana Toffee
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Strawberry & Blueberry
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                      Passionfruit & Grape
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 8: Bunny Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {bunnyCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover scale-125 transition-all duration-1000 group-hover:scale-150 ${
                      index === currentBunnyCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {bunnyCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentBunnyCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentBunnyCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Bunny Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Bubblegum
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                      Raspberry
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Passionfruit & Mango
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 9: Stars Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {starsCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover scale-[1.8] transition-all duration-1000 group-hover:scale-[2.0] ${
                      index === currentStarsCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {starsCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentStarsCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentStarsCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Stars Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Tutti-Frutti
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Lemon
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      Blueberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 10: Icecream Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {icecreamCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentIcecreamCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {icecreamCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentIcecreamCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentIcecreamCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Icecream Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-500 rounded-full mr-3"></div>
                      Strawberry & Vanilla
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Tutti-Frutti
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                      Mango & Lychee
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 11: Heart Candy 2 */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {heart2CandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentHeart2CarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {heart2CandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentHeart2CarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentHeart2CarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Heart Candy
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Flavors Include:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      Tutti-Frutti
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                      Watermelon
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      Lemon & Blueberry
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>

            {/* Tile 12: Mixed Candy */}
            <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group border-4 border-transparent hover:border-kato-cyan" style={{ backgroundColor: '#221D58' }}>
              <div className="relative h-64 overflow-hidden">
                {mixedCandyImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 ${
                      index === currentMixedCarouselImage 
                        ? 'opacity-100 transform translate-x-0' 
                        : 'opacity-0 transform translate-x-full'
                    }`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {mixedCandyImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentMixedCarouselImage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentMixedCarouselImage 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-black mb-4 transition-colors" style={{ color: '#F5ED3A' }}>
                  Mixed
                </h3>
                <div className="mb-6">
                  <h4 className="font-black mb-3 text-lg text-white">Shapes & Flavors:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-pink-400 rounded-full mr-3"></div>
                      Kärlek
                    </li>
                    <li className="flex items-center text-white">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
                      Glädje
                    </li>
                    <li className="flex items-center text-transparent">
                      <div className="w-2 h-2 bg-transparent rounded-full mr-3"></div>
                      &nbsp;
                    </li>
                  </ul>
                </div>
                <a
                  href="/contact#quote"
                  className="w-full py-4 rounded-2xl text-xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-xl hover:scale-105 inline-flex items-center justify-center"
                  style={{ backgroundColor: '#F5ED3A', color: '#221D58' }}
                >
                  Order Now!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customization Text Section */}
      <section className="py-24 relative bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h2 className="text-5xl md:text-6xl font-black mb-8 text-kato-navy">
              Custom <span className="text-kato-cyan">Options</span>
            </h2>
            <p className="text-2xl md:text-3xl font-bold text-kato-navy max-w-4xl mx-auto leading-relaxed">
              We offer customized products tailored to your brand. Shapes, flavors and colors can be specifically created to meet all your sweet wishes
            </p>
          </div>
        </div>
      </section>

      {/* Quality Features - Bold Cards */}
      <section className="py-20 bg-kato-navy text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-kato-navy to-purple-900"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black mb-6">
              QUALITY <span className="text-kato-yellow">GUARANTEED!</span>
            </h2>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Every batch meets our strict standards for consistent taste, texture, and presentation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-lg p-10 rounded-3xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 group text-center">
              <div className="w-20 h-20 bg-kato-yellow rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform">
                <Shield className="w-10 h-10 text-kato-navy" />
              </div>
              <h3 className="text-3xl font-black mb-6 group-hover:text-kato-yellow transition-colors">
                PREMIUM INGREDIENTS
              </h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Only the finest European ingredients are used in our Swedish-style confections.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-lg p-10 rounded-3xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 group text-center">
              <div className="w-20 h-20 bg-kato-cyan rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform">
                <Star className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-3xl font-black mb-6 group-hover:text-kato-cyan transition-colors">
                CONSISTENT QUALITY
              </h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Rigorous quality control ensures every batch meets our exacting standards.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-lg p-10 rounded-3xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 group text-center">
              <div className="w-20 h-20 bg-kato-yellow rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform">
                <Truck className="w-10 h-10 text-kato-navy" />
              </div>
              <h3 className="text-3xl font-black mb-6 group-hover:text-kato-yellow transition-colors">
                RELIABLE DELIVERY
              </h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Fresh products delivered on time, every time, with proper temperature control.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Massive Impact */}
      <section className="py-20 bg-gradient-to-r from-kato-yellow to-kato-cyan text-kato-navy relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=%2260%22 height=%2260%22 viewBox=%220 0 60 60%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cg fill=%22%23FFFFFF%22 fill-opacity=%220.1%22%3E%3Ccircle cx=%227%22 cy=%227%22 r=%223%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <div className="animate-fadeInUp">
            <h2 className="text-5xl md:text-7xl font-black mb-8">
              READY TO ORDER?
            </h2>
            <p className="text-2xl mb-12 opacity-90 max-w-4xl mx-auto font-medium">
              Get in touch with our <span className="font-black">wholesale team</span> to discuss your needs, 
              request samples, or place your first order.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link
                to="/contact"
                className="bg-kato-navy text-white px-12 py-6 rounded-full text-2xl font-black hover:bg-opacity-90 transition-all duration-300 hover:shadow-2xl hover:scale-105 inline-flex items-center justify-center"
              >
                CONTACT SALES TEAM
              </Link>
              <Link
                to="/story"
                className="border-4 border-kato-navy text-kato-navy px-12 py-6 rounded-full text-2xl font-black hover:bg-kato-navy hover:text-white transition-all duration-300 hover:scale-105 inline-flex items-center justify-center"
              >
                LEARN OUR STORY
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;